module.exports = __webpack_public_path__ + "img/text2000.ee0be9c5.png";